import { apiClient } from '@/lib/api/client';
import { API_ENDPOINTS } from '@/lib/api/config';
import type {
  SortingSession,
  SortingSessionItem,
  SortingPageScan,
  ScanContainerRequest,
  ScanPageRequest,
  RefuseContainerRequest,
  SortingListParams,
  SortingMetrics
} from '../types';

const { SORTING } = API_ENDPOINTS;

export const sortingApi = {
  getSessions: (params?: SortingListParams) =>
    apiClient.getPaginated<SortingSession>(SORTING.SESSIONS, params),

  getSession: (id: number) =>
    apiClient.get<SortingSession>(SORTING.SESSION(id)),

  metrics: () => apiClient.get<SortingMetrics>(SORTING.METRICS),

  bulkDelete: (
    params:
      | { ids: number[] }
      | { all: true; filters: Partial<SortingListParams> }
  ) => apiClient.post(SORTING.BULK_DELETE, params),

  start: (sessionId: number) =>
    apiClient.post<SortingSession>(SORTING.START(sessionId)),

  scan: (sessionId: number, data: ScanContainerRequest) =>
    apiClient.post<SortingSessionItem>(SORTING.SCAN(sessionId), data),

  scanPage: (sessionId: number, data: ScanPageRequest) =>
    apiClient.post<SortingPageScan>(SORTING.SCAN_PAGE(sessionId), data),

  completeContainer: (sessionId: number, data: { item_id: number }) =>
    apiClient.post<SortingSessionItem>(
      SORTING.COMPLETE_CONTAINER(sessionId),
      data
    ),

  refuse: (sessionId: number, data: RefuseContainerRequest) =>
    apiClient.post<SortingSessionItem>(SORTING.REFUSE(sessionId), data),

  complete: (sessionId: number) =>
    apiClient.post<SortingSession>(SORTING.COMPLETE(sessionId))
};
